'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _class, _temp;
/**
 * Форма ввода пароля или сброса выводится только тогда, когда найден конкретный пользователь.
 * Пока он не найден, выводится форма для поиска пользователя.
 * Когда пользователь найден, тогда переходим к нему и выбираем.
 */
// import Users from "./Users";
// import Dialog, {
//   DialogActions,
//   DialogContent,
//   DialogTitle,
// } from 'material-ui/Dialog';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withStyles = require('material-ui/styles/withStyles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _component = require('@prisma-cms/component');

var _component2 = _interopRequireDefault(_component);

var _Signin = require('./forms/Signin');

var _Signin2 = _interopRequireDefault(_Signin);

var _Signup = require('./forms/Signup');

var _Signup2 = _interopRequireDefault(_Signup);

var _Metamask = require('./forms/Metamask');

var _Metamask2 = _interopRequireDefault(_Metamask);

var _Button = require('material-ui/Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = {
  root: {} // width: 360,
  // DialogContentRoot: {
  //   display: "flex",
  //   flexDirection: "column",
  //   flexBasis: "100%",
  //   alignItems: "center",
  // },

};
var Auth = (_temp = _class = function (_PrismaCmsComponent) {
  _inherits(Auth, _PrismaCmsComponent);

  function Auth(props) {
    _classCallCheck(this, Auth);

    var _this = _possibleConstructorReturn(this, (Auth.__proto__ || Object.getPrototypeOf(Auth)).call(this, props));

    var step = props.step;
    _this.state = _extends({}, _this.state, {
      step: step // open: true,

    });
    return _this;
  }

  _createClass(Auth, [{
    key: 'renderForm',
    value: function renderForm() {
      var step = this.state.step;
      var form = void 0;

      switch (step) {
        // case "findUser":
        case "signin":
          form = this.renderSigninForm();
          break;

        case "signup":
          form = this.renderSignupForm();
          break;

        case "metamask":
          form = this.renderMetamaskForm();
          break;
      }

      return form;
    }
  }, {
    key: 'renderSigninForm',
    value: function renderSigninForm() {
      var _this2 = this;

      var _props = this.props,
          open = _props.open,
          loginCanceled = _props.loginCanceled,
          loginComplete = _props.loginComplete,
          useMetamask = _props.useMetamask;
      return _react2.default.createElement(_Signin2.default, {
        open: open,
        loginCanceled: loginCanceled,
        loginComplete: loginComplete,
        useMetamask: useMetamask,
        switchForm: function switchForm(form) {
          _this2.setState({
            step: form
          });
        }
      });
    }
  }, {
    key: 'renderSignupForm',
    value: function renderSignupForm() {
      var _this3 = this;

      var _props2 = this.props,
          open = _props2.open,
          loginCanceled = _props2.loginCanceled,
          loginComplete = _props2.loginComplete,
          useMetamask = _props2.useMetamask;
      return _react2.default.createElement(_Signup2.default, {
        open: open,
        loginCanceled: loginCanceled,
        loginComplete: loginComplete,
        useMetamask: useMetamask,
        switchForm: function switchForm(form) {
          _this3.setState({
            step: form
          });
        }
      });
    }
  }, {
    key: 'renderMetamaskForm',
    value: function renderMetamaskForm() {
      var _this4 = this;

      var _props3 = this.props,
          open = _props3.open,
          loginCanceled = _props3.loginCanceled,
          loginComplete = _props3.loginComplete;
      return _react2.default.createElement(_Metamask2.default, {
        open: open,
        loginCanceled: loginCanceled,
        loginComplete: loginComplete,
        switchForm: function switchForm(form) {
          _this4.setState({
            step: form
          });
        }
      });
    }
  }, {
    key: 'getFilters',
    value: function getFilters() {
      var uri = this.context.uri;

      var _uri$query = uri.query(true),
          page = _uri$query.page,
          filters = _uri$query.authFilters;

      if (filters) {
        try {
          filters = filters && JSON.parse(filters) || null;
        } catch (error) {
          console.error(console.error(error));
        }
      }

      return filters;
    }
  }, {
    key: 'setFilters',
    value: function setFilters(filters) {
      var _context = this.context,
          uri = _context.uri,
          history = _context.router.history;
      var newUri = uri.clone();
      var currentFilters = this.getFilters();
      filters = _extends({}, currentFilters, filters);

      try {
        filters = filters ? JSON.stringify(filters) : undefined;
      } catch (error) {
        console.error(error);
      }

      if (filters === "{}") {
        filters = undefined;
      }

      if (filters) {
        // if (newUri.hasQuery) {
        newUri = newUri.setQuery({
          authFilters: filters
        }); // }
        // else {
        //   newUri = newUri.addQuery({
        //     filters,
        //   });
        // }
      } else {
        newUri.removeQuery("authFilters");
      }

      newUri.removeQuery("authPage");
      var url = newUri.resource();
      history.push(url);
    }
  }, {
    key: 'cleanFilters',
    value: function cleanFilters() {
      var _context2 = this.context,
          uri = _context2.uri,
          history = _context2.router.history;
      var newUri = uri.clone();
      newUri.removeQuery("authPage");
      newUri.removeQuery("authFilters");
      var url = newUri.resource();
      history.push(url);
    }
  }, {
    key: 'prepareWhere',
    value: function prepareWhere() {
      var _ref = this.getFilters() || {},
          where = _ref.where; // let where;
      // if (search) {
      //   where = {
      //     OR: [
      //       {
      //         id: search,
      //       },
      //       {
      //         username_contains: search,
      //       },
      //       {
      //         email_contains: search,
      //       },
      //       {
      //         fullname_contains: search,
      //       },
      //       {
      //         phone_contains: search,
      //       },
      //     ],
      //   };
      // }


      return where;
    }
  }, {
    key: 'renderActions',
    value: function renderActions() {
      return _react2.default.createElement(_react.Fragment, null, _react2.default.createElement(_Button2.default, {
        onClick: this.handleClose // color="primary"

      }, "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F"), _react2.default.createElement(_Button2.default, {
        onClick: this.handleClose // color="primary"

      }, "\u041E\u0442\u043C\u0435\u043D\u0430"), _react2.default.createElement(_Button2.default, {
        onClick: this.handleClose,
        color: 'primary',
        autoFocus: true
      }, 'Agree'));
    }
  }, {
    key: 'render',
    value: function render() {
      return this.renderForm() || null;
    }
  }]);

  return Auth;
}(_component2.default), _class.propTypes = _extends({}, _component2.default.propTypes, {
  loginCanceled: _propTypes2.default.func.isRequired,
  loginComplete: _propTypes2.default.func.isRequired,
  step: _propTypes2.default.oneOf([// "findUser",
  "signin", "signup"]).isRequired,
  classes: _propTypes2.default.object.isRequired,
  useMetamask: _propTypes2.default.bool.isRequired
}), _class.defaultProps = _extends({}, _component2.default.defaultProps, {
  step: "signin",
  showRegForm: true,
  allowPasswordRecovery: true,
  first: 2,
  fullWidth: true,
  maxWidth: "xs",
  useMetamask: true
}), _temp);
exports.default = (0, _withStyles2.default)(styles)(function (props) {
  return _react2.default.createElement(Auth, props);
});
module.exports = exports['default'];